"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AmPalette", {
  enumerable: true,
  get: function get() {
    return _amPalette.AmPalette;
  }
});
Object.defineProperty(exports, "amPalette", {
  enumerable: true,
  get: function get() {
    return _amPalette.amPalette;
  }
});
Object.defineProperty(exports, "bluePalette", {
  enumerable: true,
  get: function get() {
    return _bluePalette.bluePalette;
  }
});
Object.defineProperty(exports, "BluePalette", {
  enumerable: true,
  get: function get() {
    return _bluePalette.BluePalette;
  }
});
Object.defineProperty(exports, "blueSpectrum", {
  enumerable: true,
  get: function get() {
    return _bluePalette.bluePalette;
  }
});
Object.defineProperty(exports, "CosmicPalette", {
  enumerable: true,
  get: function get() {
    return _cosmicPalette.CosmicPalette;
  }
});
Object.defineProperty(exports, "cosmicPalette", {
  enumerable: true,
  get: function get() {
    return _cosmicPalette.cosmicPalette;
  }
});
Object.defineProperty(exports, "EdisonPalette", {
  enumerable: true,
  get: function get() {
    return _edisonPalette.EdisonPalette;
  }
});
Object.defineProperty(exports, "edisonPalette", {
  enumerable: true,
  get: function get() {
    return _edisonPalette.edisonPalette;
  }
});
Object.defineProperty(exports, "EinsteinPalette", {
  enumerable: true,
  get: function get() {
    return _einsteinPalette.EinsteinPalette;
  }
});
Object.defineProperty(exports, "einsteinPalette", {
  enumerable: true,
  get: function get() {
    return _einsteinPalette.einsteinPalette;
  }
});
Object.defineProperty(exports, "GammaPalette", {
  enumerable: true,
  get: function get() {
    return _gammaPalette.GammaPalette;
  }
});
Object.defineProperty(exports, "gammaPalette", {
  enumerable: true,
  get: function get() {
    return _gammaPalette.gammaPalette;
  }
});
Object.defineProperty(exports, "GrayPalette", {
  enumerable: true,
  get: function get() {
    return _grayPalette.GrayPalette;
  }
});
Object.defineProperty(exports, "grayPalette", {
  enumerable: true,
  get: function get() {
    return _grayPalette.grayPalette;
  }
});
Object.defineProperty(exports, "GreyPalette", {
  enumerable: true,
  get: function get() {
    return _grayPalette.GrayPalette;
  }
});
Object.defineProperty(exports, "greyPalette", {
  enumerable: true,
  get: function get() {
    return _grayPalette.grayPalette;
  }
});
Object.defineProperty(exports, "greenPalette", {
  enumerable: true,
  get: function get() {
    return _greenPalette.greenPalette;
  }
});
Object.defineProperty(exports, "GreenPalette", {
  enumerable: true,
  get: function get() {
    return _greenPalette.GreenPalette;
  }
});
Object.defineProperty(exports, "greenSpectrum", {
  enumerable: true,
  get: function get() {
    return _greenPalette.greenPalette;
  }
});
Object.defineProperty(exports, "InfraredPalette", {
  enumerable: true,
  get: function get() {
    return _infraredPalette.InfraredPalette;
  }
});
Object.defineProperty(exports, "infraredPalette", {
  enumerable: true,
  get: function get() {
    return _infraredPalette.infraredPalette;
  }
});
Object.defineProperty(exports, "OpticPalette", {
  enumerable: true,
  get: function get() {
    return _opticPalette.OpticPalette;
  }
});
Object.defineProperty(exports, "opticPalette", {
  enumerable: true,
  get: function get() {
    return _opticPalette.opticPalette;
  }
});
Object.defineProperty(exports, "orangePalette", {
  enumerable: true,
  get: function get() {
    return _orangePalette.orangePalette;
  }
});
Object.defineProperty(exports, "OrangePalette", {
  enumerable: true,
  get: function get() {
    return _orangePalette.OrangePalette;
  }
});
Object.defineProperty(exports, "orangeSpectrum", {
  enumerable: true,
  get: function get() {
    return _orangePalette.orangePalette;
  }
});
Object.defineProperty(exports, "PrismPalette", {
  enumerable: true,
  get: function get() {
    return _prismPalette.PrismPalette;
  }
});
Object.defineProperty(exports, "prismPalette", {
  enumerable: true,
  get: function get() {
    return _prismPalette.prismPalette;
  }
});
Object.defineProperty(exports, "RadarPalette", {
  enumerable: true,
  get: function get() {
    return _radarPalette.RadarPalette;
  }
});
Object.defineProperty(exports, "radarPalette", {
  enumerable: true,
  get: function get() {
    return _radarPalette.radarPalette;
  }
});
Object.defineProperty(exports, "redPalette", {
  enumerable: true,
  get: function get() {
    return _redPalette.redPalette;
  }
});
Object.defineProperty(exports, "RedPalette", {
  enumerable: true,
  get: function get() {
    return _redPalette.RedPalette;
  }
});
Object.defineProperty(exports, "redSpectrum", {
  enumerable: true,
  get: function get() {
    return _redPalette.redPalette;
  }
});
Object.defineProperty(exports, "UltravioletPalette", {
  enumerable: true,
  get: function get() {
    return _ultravioletPalette.UltravioletPalette;
  }
});
Object.defineProperty(exports, "ultravioletPalette", {
  enumerable: true,
  get: function get() {
    return _ultravioletPalette.ultravioletPalette;
  }
});
Object.defineProperty(exports, "yellowPalette", {
  enumerable: true,
  get: function get() {
    return _yellowPalette.yellowPalette;
  }
});
Object.defineProperty(exports, "YellowPalette", {
  enumerable: true,
  get: function get() {
    return _yellowPalette.YellowPalette;
  }
});
Object.defineProperty(exports, "yellowSpectrum", {
  enumerable: true,
  get: function get() {
    return _yellowPalette.yellowPalette;
  }
});
exports["default"] = exports.allDataVizColors = exports.allColors = exports.mainColors = void 0;

var _amPalette = require("./am-palette");

var _bluePalette = require("./blue-palette");

var _cosmicPalette = require("./cosmic-palette");

var _edisonPalette = require("./edison-palette");

var _einsteinPalette = require("./einstein-palette");

var _gammaPalette = require("./gamma-palette");

var _grayPalette = require("./gray-palette");

var _greenPalette = require("./green-palette");

var _infraredPalette = require("./infrared-palette");

var _opticPalette = require("./optic-palette");

var _orangePalette = require("./orange-palette");

var _prismPalette = require("./prism-palette");

var _radarPalette = require("./radar-palette");

var _redPalette = require("./red-palette");

var _ultravioletPalette = require("./ultraviolet-palette");

var _yellowPalette = require("./yellow-palette");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mainColors = {
  green: _greenPalette.greenPalette.tempusGreen,
  blue: _bluePalette.bluePalette.tempusBlue,
  // tempus standard blue. Primary buttons, clickable elements and links
  red: _redPalette.redPalette.tempusRed,
  orange: _orangePalette.orangePalette.tempusOrange,
  yellow: _yellowPalette.yellowPalette.tempusYellow
};
exports.mainColors = mainColors;

var allColors = _objectSpread({}, mainColors, {}, _greenPalette.greenPalette, {}, _redPalette.redPalette, {}, _orangePalette.orangePalette, {}, _yellowPalette.yellowPalette, {}, _bluePalette.bluePalette, {}, _grayPalette.grayPalette);

exports.allColors = allColors;

var allDataVizColors = _objectSpread({}, _gammaPalette.gammaPalette, {}, _ultravioletPalette.ultravioletPalette, {}, _cosmicPalette.cosmicPalette, {}, _prismPalette.prismPalette, {}, _opticPalette.opticPalette, {}, _einsteinPalette.einsteinPalette, {}, _edisonPalette.edisonPalette, {}, _infraredPalette.infraredPalette, {}, _radarPalette.radarPalette, {}, _amPalette.amPalette);

exports.allDataVizColors = allDataVizColors;
var _default = allColors;
exports["default"] = _default;